import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  copyPreviewsBtn: {
    minWidth: 124
  }
})

export default useStyles
